import { ProductStockingContainer } from '@/features/decisions/components/product-stocking/ProductStockingContainer';

export function ProductStockingLocationDetail() {
  return <ProductStockingContainer />;
}
